
export const amenitiesList = [
  { value: 'wifi', ar: 'واي فاي', en: 'Wi-Fi' },
  { value: 'air_conditioning', ar: 'تكييف', en: 'Air Conditiing' },
  { value: 'furnished', ar: 'مفروش', en: 'Furnished' },
  { value: 'hot_water', ar: 'سخان مياه', en: 'Water Heater' },
  { value: 'balcony', ar: 'بلكونة', en: 'Balcony' },
  { value: 'natural_gas', ar: 'غاز طبيعي', en: 'Natural Gas' },
  { value: 'elevator', ar: 'مصعد', en: 'Elevator' },
  { value: 'garden', ar: 'حديقة', en: 'Garden' },
  { value: 'kitchen', ar: 'مطبخ مجهز', en: 'Equipped Kitchen' },
  { value: 'oven', ar: 'فرن', en: 'Oven' },
  { value: 'microwave', ar: 'ميكروويف', en: 'Microwave' },
  { value: 'fan', ar: 'مروحة', en: 'Fan' },
  { value: 'desk', ar: 'مكتب', en: 'Desk' },
  { value: 'washingmachine', ar: 'غسالة ملابس', en: 'Cloth Washing machine' },
  { value: 'wardrobe', ar: 'دولاب', en: 'Wardrobe' },
  { value: 'dresser', ar: 'تسريحة', en: 'Dresser' },
  { value: 'dishwasher', ar: 'غسالة أطباق', en: 'Dishwasher' },
];

export const getAmenitiesAr = (amenitiesObj) => {
  return amenitiesList
    .filter(amenity => amenitiesObj?.[amenity.value])
    .map(amenity => amenity.ar);
};

export const getAmenitiesEn = (amenitiesObj) => {
  return amenitiesList
    .filter(amenity => amenitiesObj?.[amenity.value])
    .map(amenity => amenity.en);
};

export const getAmenitiesValues = (amenitiesObj) => {
  return amenitiesList
    .filter(amenity => amenitiesObj?.[amenity.value])
    .map(amenity => amenity.value);
};